import React from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import HeroEditorial from "../img/HEROEDITORIAL.jpg";
import magazineLogo from "../img/revista_logo.PNG";
import "../styles/BannerEditorial.css";

const BannerEditorial = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();

  const handleClick = () => {
    sessionStorage.setItem("scrollToMagazine", "true");
    navigate("/editorial");
  };

  return (
    <div className="banner-editorial" onClick={handleClick}>
      {/* Imagen de fondo */}
      <div className="banner-background">
        <img src={HeroEditorial} alt="Hero Editorial" />
      </div>

      {/* Contenido del banner */}
      <div className="banner-content">
        <img src={magazineLogo} alt="Magazine Logo" className="magazine-logo" />
        <p className="banner-text">
          {language === "ES"
            ? "Accede a nuestro último trabajo editorial"
            : "Accedeix al nostre darrer treball editorial"}
        </p>
      </div>
    </div>
  );
};

export default BannerEditorial;
